import React, {useEffect, useState} from "react";
import useSerializedRefresh from "../../../useSerializedRefresh";
import ApiService from "../../../../../services/ApiService";
import ProgressBar from "@ramonak/react-progress-bar";
import {notification, Typography} from "antd";
import {uuidv4} from "../../../../../utils";
import {getDeviseSymbol} from "../../../../../i18n";

const {Text,Title}=Typography

export default function ScreenDonSection({context,campagneData,})
{
    const [loading,setLoading]=useState(true)
    const [dons,setDons]=useState([])

    const formater=new Intl.NumberFormat('fr-FR', { maximumFractionDigits:0,style:"currency",currency:"EUR" })
    const formater2=new Intl.NumberFormat('fr-FR', { maximumFractionDigits:0})

    const partnerMontant=campagneData?.partnerMontant || 1

    let donorName=campagneData.config?.donorName || "Parrainages"

    const screenOptions=campagneData?.screenOptions || {}


    const getDisplayName=(campagneExtraData={})=>{
        return campagneExtraData?.displayName || "Anonyme"
    }

    const getDons=async ()=>{
        let url="/campagne/donors/"+campagneData.id

        const res=await ApiService.get(url)
        let _dons=res.data

        if(screenOptions.minMontant){
            _dons=_dons.filter(i=>i.montant>=screenOptions.minMontant)
        }

        setDons(_dons)
        setLoading(false)
    }

    useSerializedRefresh(getDons, campagneData?._liveRevision)


    if(loading){
        return null
    }

    return (
        <div style={{display:"flex",justifyContent:"center",alignItems:"center",padding:"0 1vw"}}>
            <div style={{overflow:"visible",width:"73%",height:"15vh",display:"flex",alignItems:"center",flexDirection:"row-reverse",gap:150}}>
                {dons.map((d,index)=>{

                    //console.log(index)

                    let className="screen-don-card"
                    let className2=""

                    if(index<3){
                        className2+=" screenDonFadeIn"
                    }else{
                        className2+=" screenDonFadeOut"
                    }

                    //console.log(className)

                    const nb=formater2.format(d.montant/partnerMontant)
                    const text=nb>1?"Étincelles":"Étincelle"

                    return(
                        <div style={{position:"relative"}} className={className2} key={d.id}>
                            <div style={{flexDirection:"column",border:"0px solid red",overflow:"hidden"}} className={className}>
                                <div style={{height:"50%",width:"100%",backgroundColor:"rgb(245,230,191)",display:"flex",justifyContent:"center",alignItems:"center"}}>
                                    <span style={{color:"#0f4f52",fontSize:"4vh",textAlign:"center",fontFamily:"Cerapro-Bold"}}>
                                        {nb} {text}
                                    </span>
                                </div>
                                <div style={{height:"50%",width:"100%",backgroundColor:"#FFF",display:"flex",justifyContent:"center",alignItems:"center"}}>
                                    <span style={{color:"#000",fontSize:"3vh",textAlign:"center",fontFamily:"Cerapro-Bold !important"}}>{getDisplayName(d.campagneExtraData)}</span>
                                </div>
                            </div>
                        </div>

                    )
                })}
            </div>
        </div>
    )
}
